import * as React from "react";
const SvgArrowHeadRight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 32, viewBox: "0 0 17 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1L16 16L1 31", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgArrowHeadRight;
